import React, { useCallback, useState } from 'react'
import { MissingScopeAction } from '../../../../../components/ScopedBlock/models'
import { ScopedBlock } from '../../../../../components/ScopedBlock/ScopedBlock'
import { Button } from '../../../../../components/Button/Button'
import { InviteUserModal } from '../../../../ManageTeam/InviteUserModal'
import { useGetUsersQuery } from '../../../../../store/user/user'
import { TrackEvent, useTracking } from '../../../../../apps/professional-app/fa/common/tracking'
import { useAppSelector } from '../../../../../store/hooks'
import { selectAccountId } from '../../../../../store/auth/authSlice'
import { useZocksQuota } from '../../../../../components/ScopedBlock/hooks'
import { PresetConfigLoader } from './PresetConfigLoader'

export const InviteTeamMembers: React.FC = () => {
  const accountId = useAppSelector(selectAccountId)

  const { tracked } = useTracking()
  const { getValue, quotas } = useZocksQuota()

  const { data: users } = useGetUsersQuery({ accountId, pageRequest: { page: 0, size: 10 }, identityTypes: ['idp'] })

  const checkInvitationEnabled = useCallback(() => {
    if (users && quotas) {
      const { value: maxSeats } = getValue(quotas?.data, 'identity.maxSeats')
      return maxSeats > users.page.totalElements || maxSeats > 1 || maxSeats === null
    }
    return false
  }, [users, quotas, getValue])

  const [showInviteUserModal, setShowInviteUserModal] = useState<boolean>(false)
  const handleInviteUserOnClick = tracked(
    () => {
      setShowInviteUserModal(true)
    },
    { eventName: TrackEvent.INVITE_USER_CLICKED },
  )

  const handleInviteUserModalHide = () => {
    setShowInviteUserModal(false)
  }

  if (!users || !quotas) {
    return <PresetConfigLoader />
  }

  return (
    <>
      {showInviteUserModal ? <InviteUserModal onHide={handleInviteUserModalHide} /> : null}
      <div className='d-flex py-4 px-3 zocks-bg-color-gray-100 invite-team-members-container justify-content-between align-items-center'>
        <div className='paragraph-medium'>You don't have any team members.</div>
        <ScopedBlock
          scope={{
            scope: 'consoleuser:invite',
            superScope: ['consoleuser:admin'],
          }}
          missingScopeAction={MissingScopeAction.DISABLE}
        >
          <ScopedBlock authActions={[checkInvitationEnabled]} missingScopeAction={MissingScopeAction.UPGRADE}>
            <Button variant='primary' onClick={handleInviteUserOnClick}>
              <i className='bi bi-plus' />
              Invite user
            </Button>
          </ScopedBlock>
        </ScopedBlock>
      </div>
    </>
  )
}
